'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
require('styled-components');
require('lodash/get');
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../settings-9ee2f03f.js');
require('lodash/camelCase');
require('lodash/upperFirst');
var icon = require('../icon.js');
require('../style-222d2b0f.js');
require('../typography/span.js');
var isFunction = _interopDefault(require('lodash/isFunction'));
require('../typography/t24.js');
require('../buttons-color-d198c1b7.js');
require('../button/button-icon.js');
var mobileInfoOverlay = require('../mobile-info-overlay.js');
var styled$1 = require('./styled.js');
var _const = require('../const-7e9ce2ed.js');

var ComponentTooltip = function (_React$Component) {
  _babelHelpers.inherits(ComponentTooltip, _React$Component);

  function ComponentTooltip(props) {
    _babelHelpers.classCallCheck(this, ComponentTooltip);

    var _this = _babelHelpers.possibleConstructorReturn(this, (ComponentTooltip.__proto__ || Object.getPrototypeOf(ComponentTooltip)).call(this, props));

    _this.state = {
      displayTooltip: false
    };
    _this.hideTooltip = _this.hideTooltip.bind(_this);
    _this.showTooltip = _this.showTooltip.bind(_this);
    _this.handleCloseTooltip = _this.handleCloseTooltip.bind(_this);
    return _this;
  }

  _babelHelpers.createClass(ComponentTooltip, [{
    key: "hideTooltip",
    value: function hideTooltip() {
      var customCloseFunction = this.props.customCloseFunction;

      this.setState({ displayTooltip: false });
      if (isFunction(customCloseFunction)) {
        customCloseFunction();
      }
    }
  }, {
    key: "showTooltip",
    value: function showTooltip() {
      var customOpenFunction = this.props.customOpenFunction;

      this.setState({ displayTooltip: true });
      if (isFunction(customOpenFunction)) {
        customOpenFunction();
      }
    }
  }, {
    key: "handleCloseTooltip",
    value: function handleCloseTooltip(e) {
      e.stopPropagation();
      this.hideTooltip();
    }
  }, {
    key: "getPosition",
    value: function getPosition(position) {
      switch (position) {
        case "TOP":
        case "BOTTOM":
        case "RIGHT":
        case "LEFT":
          return _const.COMPONENT_TOOL_TIPS_POSITIONS[position];
        case "CUSTOM":
          {
            var positionCustom = this.props.positionCustom;

            return positionCustom;
          }
        default:
          return _const.COMPONENT_TOOL_TIPS_POSITIONS.RIGHT;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var displayTooltip = this.state.displayTooltip;
      var _props = this.props,
          bubbleWidth = _props.bubbleWidth,
          children = _props.children,
          position = _props.position,
          tooltipElement = _props.tooltipElement,
          mobileTitle = _props.mobileTitle,
          shouldShowTooltip = _props.shouldShowTooltip,
          showOnlyDesktop = _props.showOnlyDesktop,
          showOnlyMobile = _props.showOnlyMobile,
          wrapperWidth = _props.wrapperWidth,
          mobileShowWidth = _props.mobileShowWidth,
          wrapperDisplay = _props.wrapperDisplay,
          innerFlex = _props.innerFlex,
          innerFlexDirection = _props.innerFlexDirection;

      var positionToolTip = this.getPosition(position);
      return React__default.createElement(
        styled$1.ComponentTooltipWrapper,
        {
          mobileShowWidth: mobileShowWidth,
          showOnlyDesktop: showOnlyDesktop,
          showOnlyMobile: showOnlyMobile,
          width: wrapperWidth,
          display: wrapperDisplay },
        React__default.createElement(
          styled$1.TooltipContainer,
          { onClick: this.showTooltip, componentTooltip: true },
          children,
          React__default.createElement(
            "div",
            null,
            React__default.createElement(
              styled$1.TooltipBubble,
              _babelHelpers._extends({
                mobileShowWidth: mobileShowWidth,
                componentTooltip: true,
                isShowTooltip: displayTooltip && shouldShowTooltip,
                width: bubbleWidth
              }, positionToolTip),
              tooltipElement,
              React__default.createElement(
                styled$1.StickyCloseButton,
                { onClick: this.handleCloseTooltip },
                React__default.createElement(icon.Icon, { name: "close", size: "sm" })
              )
            )
          )
        ),
        React__default.createElement(
          styled$1.MobileTooltipWrapper,
          { mobileShowWidth: mobileShowWidth },
          React__default.createElement(
            mobileInfoOverlay.default,
            {
              title: mobileTitle,
              showOverlay: displayTooltip && shouldShowTooltip,
              onClickCloseButton: this.hideTooltip,
              innerFlex: innerFlex,
              innerFlexDirection: innerFlexDirection },
            tooltipElement
          )
        )
      );
    }
  }]);
  return ComponentTooltip;
}(React__default.Component);


ComponentTooltip.propTypes = {
  /** indicator for tooltip position */
  position: PropTypes$1.oneOf(["TOP", "BOTTOM", "RIGHT", "LEFT", "CUSTOM"]),
  /** width of tooltip */
  bubbleWidth: PropTypes$1.string,
  /** tooltip element use for render in the tooltip popup */
  tooltipElement: PropTypes$1.element.isRequired,
  /** title for mobile tooltip */
  mobileTitle: PropTypes$1.string,
  /** optional indicator for show tooltip it will do AND operation with internal show indicator */
  shouldShowTooltip: PropTypes$1.bool,
  /** additional function that will get call when you close the tooltip */
  customCloseFunction: PropTypes$1.func,
  /** additional function that will get call when you open the tooltip */
  customOpenFunction: PropTypes$1.func,
  /** maximum width of the mobile style */
  mobileShowWidth: PropTypes$1.string,
  /** indicator for hide the component in mobile */
  showOnlyDesktop: PropTypes$1.bool,
  /** indicator for hide the component in desktop */
  showOnlyMobile: PropTypes$1.bool,
  /** width of the component wrapper */
  wrapperWidth: PropTypes$1.string,
  /** display property for component wrapper */
  wrapperDisplay: PropTypes$1.string
};

ComponentTooltip.defaultProps = {
  position: "RIGHT",
  bubbleWidth: "350px",
  shouldShowTooltip: true,
  mobileShowWidth: "767px"
};
ComponentTooltip.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "hideTooltip",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "showTooltip",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleCloseTooltip",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getPosition",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "position",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "ComponentTooltip",
  "props": {
    "position": {
      "defaultValue": {
        "value": "\"RIGHT\"",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"TOP\"",
          "computed": false
        }, {
          "value": "\"BOTTOM\"",
          "computed": false
        }, {
          "value": "\"RIGHT\"",
          "computed": false
        }, {
          "value": "\"LEFT\"",
          "computed": false
        }, {
          "value": "\"CUSTOM\"",
          "computed": false
        }]
      },
      "required": false,
      "description": "indicator for tooltip position"
    },
    "bubbleWidth": {
      "defaultValue": {
        "value": "\"350px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "width of tooltip"
    },
    "shouldShowTooltip": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "optional indicator for show tooltip it will do AND operation with internal show indicator"
    },
    "mobileShowWidth": {
      "defaultValue": {
        "value": "\"767px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "maximum width of the mobile style"
    },
    "tooltipElement": {
      "type": {
        "name": "element"
      },
      "required": true,
      "description": "tooltip element use for render in the tooltip popup"
    },
    "mobileTitle": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "title for mobile tooltip"
    },
    "customCloseFunction": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "additional function that will get call when you close the tooltip"
    },
    "customOpenFunction": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "additional function that will get call when you open the tooltip"
    },
    "showOnlyDesktop": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for hide the component in mobile"
    },
    "showOnlyMobile": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for hide the component in desktop"
    },
    "wrapperWidth": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "width of the component wrapper"
    },
    "wrapperDisplay": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "display property for component wrapper"
    }
  }
};

module.exports = ComponentTooltip;
//# sourceMappingURL=component-tooltip.js.map
